{
  "pipes": {
    "appointment_status": {
      "BLOCKER": "Chặn lịch",
      "CONFIRMED": "Xác nhận",
      "CHECKED_IN": "Checkin",
      "FULFILLED": "Hoàn tất",
      "BO_CANCELLED": "Tiệm hủy",
      "CUSTOMER_CANCELLED": "Khách hủy",
      "EXPIRED": "Quá hạn",
      "OTHER": "Khác"
    },
    "booking_type": {
      "BLOCKER": "Chặn lịch",
      "AGENT": "Trợ lý AI",
      "TELEPHONE": "Điện thoại",
      "ONLINE": "Internet",
      "TREATWELL": "Treatwell",
      "RWG": "Google"
    },
    "communication_way": {
      "EMAIL": "Email",
      "SMS": "SMS",
      "no_matter": "Không quan trọng"
    },
    "customer_type": {
      "vip": "Khách VIP",
      "new": "Khách mới",
      "regular": "Khách trung thành",
      "at_risk": "Khách lâu không đến",
      "normal": "Khách thường"
    },
    "language": {
      "cs-CZ": "Tiếng Séc",
      "de-DE": "Tiếng Đức",
      "fr-FR": "Tiếng Pháp",
      "en-US": "Tiếng Anh",
      "vi-VN": "Tiếng Việt"
    },
    "month": [
      "Tháng 1",
      "Tháng 2",
      "Tháng 3",
      "Tháng 4",
      "Tháng 5",
      "Tháng 6",
      "Tháng 7",
      "Tháng 8",
      "Tháng 9",
      "Tháng 10",
      "Tháng 11",
      "Tháng 12"
    ],
    "notification_type": {
      "NEW_APPOINTMENT": "Lịch hẹn mới",
      "APPOINTMENT_CANCELLED": "Khách hủy lịch hẹn",
      "APPOINTMENT_MESSAGE": "Tin nhắn mới",
      "BO_UPDATED": "Lịch hẹn thay đổi bởi tiệm",
      "BO_CANCELLED": "Tiệm hủy lịch hẹn"
    },
    "weekday": {
      "MONDAY": "Thứ hai",
      "TUESDAY": "Thứ ba",
      "WEDNESDAY": "Thứ tư",
      "THURSDAY": "Thứ năm",
      "FRIDAY": "Thứ sáu",
      "SATURDAY": "Thứ bảy",
      "SUNDAY": "Chủ nhật"
    },
    "weekday_short": {
      "MONDAY": "T.Hai",
      "TUESDAY": "T.Ba",
      "WEDNESDAY": "T.Tư",
      "THURSDAY": "T.Năm",
      "FRIDAY": "T.Sáu",
      "SATURDAY": "T.Bảy",
      "SUNDAY": "CN"
    },
    "review_type": {
      "all": "Tất cả đánh giá",
      "internal_only": "Chỉ đánh giá nội bộ",
      "google_only": "Chỉ đánh giá Google"
    },
    "time": {
      "day": "ngày",
      "days": "ngày",
      "hour": "giờ",
      "hours": "giờ",
      "minute": "phút",
      "minutes": "phút",
      "month": "tháng",
      "months": "tháng",
      "now": "ngay lúc này",
      "second": "giây",
      "seconds": "giây",
      "year": "năm",
      "years": "năm",
      "timestamp_in_future": "{{time}} nữa",
      "timestamp_in_the_past": "{{time}} trước",
      "today": "hôm nay"
    },
    "time_period": {
      "all": "Tất cả",
      "today": "Hôm nay",
      "yesterday": "Hôm qua",
      "this_week": "Tuần này",
      "this_month": "Tháng này",
      "last_month": "Tháng trước",
      "this_quarter": "Quý này",
      "last_quarter": "Quý trước",
      "this_year": "Năm nay",
      "last_year": "Năm trước"
    },
    "text": {
      "deleted-service": "Dịch vụ đã xóa",
      "deleted-staff": "Nhân viên đã xóa",
      "deleted-staff-passive": "Nhân viên đã xóa",
      "first-available-staff": "Nhân viên bất kỳ",
      "first-available-staff-passive": "Nhân viên bất kỳ",
      "other": "khác",
      "others": "khác",
      "to": "đến",
      "walk_in_customer": "Khách vãng lai"
    }
  }
}
